import React from 'react';
export function ESGDataPlatform() {
  return <section className="w-full bg-white py-20 sm:py-28" data-id="element-948">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-949">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center" data-id="element-950">
          <div data-id="element-951">
            <p className="text-sm font-semibold uppercase tracking-widest text-carbon-bright" data-id="element-952">
              ESG Data Management Platform
            </p>
            <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-carbon-deep tracking-tight" data-id="element-953">
              Centralize ESG activity data across every site.
            </h2>
            <p className="mt-4 text-lg text-carbon-deep" data-id="element-954">
              Collect, validate, and attach evidence in one workflow so your
              reporting stays audit-ready and decision-grade.
            </p>
          </div>
          <div className="relative" data-id="element-955">
            <div className="absolute -inset-6 bg-carbon-bright/10 blur-3xl rounded-[48px]" data-id="element-956" />
            <div className="relative rounded-3xl border border-[#9aa6af] bg-white shadow-xl overflow-hidden" data-id="element-957">
              <div className="bg-[#F5F6F7] p-4 sm:p-5" data-id="element-958">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-959">
                  {/* Compact sidebar */}
                  <div className="bg-white rounded-2xl border border-[#E5E7EB] shadow-sm p-4" data-id="element-960">
                    <div className="flex items-center justify-between rounded-xl border border-[#E5E7EB] px-3 py-2 text-xs font-semibold text-[#2C2C2C]" data-id="element-961">
                      Select Site
                      <div className="h-2 w-2 border-r-2 border-b-2 border-gray-400 rotate-45" data-id="element-962" />
                    </div>
                    <div className="mt-3 flex gap-2" data-id="element-963">
                      <div className="flex-1 rounded-xl border border-[#E5E7EB] px-3 py-2 text-xs text-gray-400" data-id="element-964">
                        Search
                      </div>
                      <button className="rounded-xl border border-[#E5E7EB] px-3 py-2 text-xs font-semibold text-gray-600" data-id="element-965">
                        Filter
                      </button>
                    </div>

                    <div className="mt-4 space-y-2" data-id="element-966">
                      <div className="flex items-center justify-between rounded-xl border border-[#E5E7EB] px-3 py-2 text-[11px] font-bold uppercase text-[#2C2C2C]" data-id="element-967">
                        ENERGY
                        <span className="rounded-full bg-[#E8F5E9] px-2 py-0.5 text-[9px] font-bold" data-id="element-968">
                          01/03
                        </span>
                      </div>
                      <div className="rounded-xl bg-[#4CAF50] px-3 py-2 text-xs font-semibold text-white" data-id="element-969">
                        Petrol
                      </div>
                      <div className="flex items-center justify-between rounded-xl border border-[#E5E7EB] px-3 py-2 text-xs font-semibold text-[#2C2C2C]" data-id="element-970">
                        Water
                        <span className="rounded-full bg-[#E8F5E9] px-2 py-0.5 text-[9px] font-bold" data-id="element-971">
                          03/12
                        </span>
                      </div>
                    </div>

                    <div className="mt-4" data-id="element-972">
                      <div className="text-center text-[10px] font-bold text-[#2C2C2C]" data-id="element-973">
                        65%
                      </div>
                      <div className="mt-1 h-2 w-full rounded-full bg-[#E5E7EB]" data-id="element-974">
                        <div className="h-2 w-2/3 rounded-full bg-[#4CAF50]" data-id="element-975" />
                      </div>
                    </div>
                  </div>

                  {/* Compact form + chart */}
                  <div className="space-y-4" data-id="element-976">
                    <div className="bg-white rounded-2xl border border-[#E5E7EB] shadow-sm p-4" data-id="element-977">
                      <div className="text-xs font-semibold text-[#2C2C2C]" data-id="element-978">
                        Reading value
                      </div>
                      <div className="mt-2 rounded-xl border border-[#E5E7EB] px-3 py-2 text-xs text-gray-400" data-id="element-979">
                        Eg: 476
                      </div>
                      <div className="mt-3 text-xs font-semibold text-[#2C2C2C]" data-id="element-980">
                        Attachment
                      </div>
                      <div className="mt-2 flex items-center gap-2" data-id="element-981">
                        <div className="flex-1 rounded-xl border border-dashed border-[#E5E7EB] px-3 py-2 text-xs text-gray-400" data-id="element-982">
                          Select file
                        </div>
                        <button className="rounded-xl bg-[#4CAF50] px-4 py-2 text-xs font-semibold text-white" data-id="element-983">
                          Upload
                        </button>
                      </div>
                    </div>

                    <div className="bg-white rounded-2xl border border-[#E5E7EB] shadow-sm p-4" data-id="element-984">
                      <div className="text-xs font-semibold text-[#2C2C2C]" data-id="element-985">
                        PETROL CONSUMED
                      </div>
                      <div className="mt-4 flex items-end gap-4" data-id="element-986">
                        <div className="h-16 w-4 rounded-full bg-[#4CAF50]" data-id="element-987" />
                        <div className="h-12 w-4 rounded-full bg-[#E5E7EB]" data-id="element-988" />
                        <div className="h-14 w-4 rounded-full bg-[#E5E7EB]" data-id="element-989" />
                        <div className="ml-auto rounded-lg border border-[#E5E7EB] bg-white px-2 py-1 text-[10px]" data-id="element-990">
                          <div className="flex items-center gap-1 font-semibold text-[#2C2C2C]" data-id="element-991">
                            <span className="h-2 w-2 rounded-sm bg-[#4CAF50]" data-id="element-992" />
                            3211 L
                          </div>
                          <div className="text-gray-500" data-id="element-993">Jan 2021</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}